import { useNavigate } from "react-router-dom";
import { INftAsset } from "../../interfaces"
import { Utils } from '../../utils'
import { Numeral } from "../Numeral";

interface INftCardProps {
  asset: INftAsset;
}
export const NftCreatorsCard = ({ asset }: INftCardProps) => {
  const navigate = useNavigate();
  const projectCode = 'NFT';
  if (!asset.image || asset.status === 'P') {
    return null;
  }
  return (
    <>
      <div className="pcard p-3" onClick={() => {
        if (asset.tokenId) {
          window.location.href = `/web/asset/detail/${asset.contractAddress}/${asset.tokenId}`;
        } else {
          navigate(`/web/asset/detail/${asset.nftId}`);
        }
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }}>
        <div className="d-flex align-items-center" style={{ height: '268px' }}>
          <img src={Utils().normalizeImagePath(asset.image, projectCode)} alt="" className="overflow-hidden mx-auto"
            style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'cover', borderRadius: '12px 12px 0 0' }} />
        </div>
        <div className="px-4 txt-12">
          <div className="my-2">{asset.name}</div>
          { asset.sellingPrice && <div className="">價格</div> }
          {
            asset.sellingPrice && <div className="d-flex align-items-center my-2">
              <img src={require("../../assets/img/nft/Tether-USDT-icon.png")} alt="" width={'18px'} />
              <span className="mx-2 txt-16"><Numeral value={asset.sellingPrice} /></span>
            </div>
          }
        </div>
      </div>
      <div className="pe-4"></div>
    </>
  )
}